const CONSENT_TEMPLATES = [
  { id: 'ctp1', name: 'Root Canal Treatment', category: 'Endodontics', fields: 14, signedCount: 312, lastUsed: 'Mar 18, 2026', status: 'Active', risk: 'Medium', version: 'v3.1', icon: 'activity', color: 'red' },
  { id: 'ctp2', name: 'Tooth Extraction', category: 'Oral Surgery', fields: 12, signedCount: 487, lastUsed: 'Mar 19, 2026', status: 'Active', risk: 'Medium', version: 'v2.4', icon: 'tool', color: 'amber' },
  { id: 'ctp3', name: 'Dental Implant Placement', category: 'Implantology', fields: 18, signedCount: 143, lastUsed: 'Mar 17, 2026', status: 'Active', risk: 'High', version: 'v4.0', icon: 'anchor', color: 'purple' },
  { id: 'ctp4', name: 'Crown & Bridge Procedure', category: 'Restorative', fields: 11, signedCount: 228, lastUsed: 'Mar 16, 2026', status: 'Active', risk: 'Low', version: 'v2.2', icon: 'shield', color: 'blue' },
  { id: 'ctp5', name: 'Orthodontic Treatment', category: 'Orthodontics', fields: 16, signedCount: 89, lastUsed: 'Mar 10, 2026', status: 'Active', risk: 'Low', version: 'v1.8', icon: 'sliders', color: 'teal' },
  { id: 'ctp6', name: 'Periodontal Surgery', category: 'Periodontics', fields: 15, signedCount: 64, lastUsed: 'Mar 8, 2026', status: 'Active', risk: 'High', version: 'v3.0', icon: 'scissors', color: 'red' },
  { id: 'ctp7', name: 'Teeth Whitening', category: 'Cosmetic', fields: 8, signedCount: 201, lastUsed: 'Mar 18, 2026', status: 'Active', risk: 'Low', version: 'v1.5', icon: 'sun', color: 'amber' },
  { id: 'ctp8', name: 'IV Sedation / Anesthesia', category: 'Anesthesia', fields: 22, signedCount: 37, lastUsed: 'Mar 14, 2026', status: 'Active', risk: 'High', version: 'v5.2', icon: 'droplet', color: 'violet' },
  { id: 'ctp9', name: 'Bone Grafting', category: 'Oral Surgery', fields: 17, signedCount: 52, lastUsed: 'Mar 12, 2026', status: 'Active', risk: 'High', version: 'v2.7', icon: 'layers', color: 'orange' },
  { id: 'ctp10', name: 'General Dental Treatment', category: 'General', fields: 9, signedCount: 634, lastUsed: 'Mar 19, 2026', status: 'Active', risk: 'Low', version: 'v1.2', icon: 'clipboard', color: 'green' },
  { id: 'ctp11', name: 'Pediatric Sedation', category: 'Pediatric', fields: 20, signedCount: 28, lastUsed: 'Mar 7, 2026', status: 'Active', risk: 'High', version: 'v3.3', icon: 'heart', color: 'pink' },
  { id: 'ctp12', name: 'Photography & Media Use', category: 'Administrative', fields: 5, signedCount: 179, lastUsed: 'Mar 15, 2026', status: 'Draft', risk: 'Low', version: 'v1.0', icon: 'camera', color: 'inkMuted' }
]

export const consentTemplates = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'templates', ctFilter: 'all' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y', flex: '1', overflow: 'auto',
    TopBar: {},

    ContentArea: {
      flow: 'y', gap: 'B', padding: 'B', flex: '1',
      '@mobileL': { padding: 'A' },

      PageHeader: {
        flow: 'x', align: 'center space-between', flexWrap: 'wrap', gap: 'Z',
        HeaderLeft: {
          flow: 'y', gap: 'X',
          PageTitle: { tag: 'h1', text: 'Consent Templates', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },
          PageSubtitle: { text: 'Manage informed consent forms for all procedures', fontSize: 'Z', color: 'inkMuted' }
        },
        NewConsentBtn: {
          tag: 'button', text: '+ New Template',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'A',
          background: 'teal', color: 'ink', border: 'none', cursor: 'pointer'
        }
      },

      StatsRow: {
        flow: 'x', gap: 'A', flexWrap: 'wrap',
        StatTemplates: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
          SVal: { text: '11', fontSize: 'C', fontWeight: '700', color: 'teal', letterSpacing: '-0.02em' },
          SLbl: { text: 'Active Templates', fontSize: 'Y', color: 'inkMuted' }
        },
        StatSigned: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
          SVal: { text: '2,454', fontSize: 'C', fontWeight: '700', color: 'green', letterSpacing: '-0.02em' },
          SLbl: { text: 'Total Signed', fontSize: 'Y', color: 'inkMuted' }
        },
        StatHighRisk: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid red.20', flex: '1', minWidth: 'F',
          SVal: { text: '5', fontSize: 'C', fontWeight: '700', color: 'red', letterSpacing: '-0.02em' },
          SLbl: { text: 'High-Risk Procedures', fontSize: 'Y', color: 'inkMuted' }
        },
        StatDraft: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid amber.20', flex: '1', minWidth: 'F',
          SVal: { text: '1', fontSize: 'C', fontWeight: '700', color: 'amber', letterSpacing: '-0.02em' },
          SLbl: { text: 'Pending Review', fontSize: 'Y', color: 'inkMuted' }
        }
      },

      FilterRow: {
        flow: 'x', gap: 'Y', flexWrap: 'wrap',
        AllPill: { tag: 'button', text: 'All', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => (s.root.ctFilter || 'all') === 'all' ? 'inkText' : 'inkSurface', color: (el, s) => (s.root.ctFilter || 'all') === 'all' ? 'ink' : 'inkMuted', onClick: (e, el, s) => s.root.update({ ctFilter: 'all' }) },
        HighPill: { tag: 'button', text: 'High Risk', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => s.root.ctFilter === 'High' ? 'red.15' : 'inkSurface', color: (el, s) => s.root.ctFilter === 'High' ? 'red' : 'inkMuted', onClick: (e, el, s) => s.root.update({ ctFilter: 'High' }) },
        MedPill: { tag: 'button', text: 'Medium Risk', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => s.root.ctFilter === 'Medium' ? 'amber.15' : 'inkSurface', color: (el, s) => s.root.ctFilter === 'Medium' ? 'amber' : 'inkMuted', onClick: (e, el, s) => s.root.update({ ctFilter: 'Medium' }) },
        LowPill: { tag: 'button', text: 'Low Risk', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => s.root.ctFilter === 'Low' ? 'green.15' : 'inkSurface', color: (el, s) => s.root.ctFilter === 'Low' ? 'green' : 'inkMuted', onClick: (e, el, s) => s.root.update({ ctFilter: 'Low' }) }
      },

      ConsentList: {
        flow: 'y', gap: 'Z',
        children: (el, s) => {
          var filter = s.root.ctFilter || 'all'
          return filter === 'all' ? CONSENT_TEMPLATES : CONSENT_TEMPLATES.filter(function (t) { return t.risk === filter })
        },
        childrenAs: 'state',
        childExtends: {
          flow: 'x', gap: 'A', align: 'center space-between',
          padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flexWrap: 'wrap',

          TemplateInfo: {
            flow: 'x', gap: 'A', align: 'center flex-start', flex: '1', minWidth: '200px',
            TemplateIconWrap: {
              width: 'D', height: 'D', round: 'Y', flexShrink: '0',
              flow: 'x', align: 'center center',
              background: (el, s) => (s.color || 'teal') + '.10',
              TIcon: { extends: 'Icon', icon: (el, s) => s.icon || 'clipboard', width: 'B', height: 'B', color: (el, s) => s.color || 'teal' }
            },
            TemplateMeta: {
              flow: 'y', gap: 'X',
              TemplateName: { text: (el, s) => s.name, fontSize: 'Z', fontWeight: '700', color: 'inkText' },
              TemplateMetaRow: {
                flow: 'x', gap: 'Z', align: 'center flex-start', flexWrap: 'wrap',
                TplCat: { tag: 'span', text: (el, s) => s.category, fontSize: 'Y', color: 'inkMuted' },
                Dot1: { tag: 'span', text: '·', fontSize: 'Y', color: 'inkMuted' },
                TplFields: { text: (el, s) => (s.fields || 0) + ' fields', fontSize: 'Y', color: 'inkMuted' },
                Dot2: { tag: 'span', text: '·', fontSize: 'Y', color: 'inkMuted' },
                TplVersion: { text: (el, s) => s.version, fontSize: 'Y', color: 'inkMuted' }
              }
            }
          },

          TemplateRight: {
            flow: 'x', gap: 'A', align: 'center center', flexShrink: '0',

            SignedCount: {
              flow: 'y', gap: 'X', align: 'flex-end flex-end',
              SignedNum: { text: (el, s) => String(s.signedCount || 0), fontSize: 'Z', fontWeight: '700', color: 'teal' },
              SignedLbl: { text: 'signed', fontSize: 'Y', color: 'inkMuted' }
            },

            RiskBadge: {
              tag: 'span',
              text: (el, s) => (s.risk || 'Low') + ' Risk',
              fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
              background: (el, s) => s.risk === 'High' ? 'red.12' : s.risk === 'Medium' ? 'amber.12' : 'green.12',
              color: (el, s) => s.risk === 'High' ? 'red' : s.risk === 'Medium' ? 'amber' : 'green'
            },

            StatusBadge: {
              tag: 'span',
              text: (el, s) => s.status,
              fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
              background: (el, s) => s.status === 'Active' ? 'teal.12' : 'amber.12',
              color: (el, s) => s.status === 'Active' ? 'teal' : 'amber'
            },

            TemplateActions: {
              flow: 'x', gap: 'Y',
              PreviewBtn: { tag: 'button', text: 'Preview', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'inkSurface', color: 'inkMuted', border: '1px solid inkBorder', cursor: 'pointer' },
              UseBtn: { tag: 'button', text: 'Use', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'teal', color: 'ink', border: 'none', cursor: 'pointer' },
              EditBtn: { tag: 'button', text: 'Edit', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', cursor: 'pointer' }
            }
          }
        }
      }
    }
  }
}
